import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';

import AccountBrandInfoComponent from '../components/brand-mappings/account-brandInfo.component';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import storePersist from '../../../../../redux/storePersist';
import { deepCopy } from '../../../../../common/services/common.service';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';

let currentChange: any = {}
const OWNER_TYPE_ACCOUNT = 68
const BrandMappingContainer = ({ onSubmit, cardDetailInfo }: any) => {
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [logoFiles, setLogoFiles] = useState<any>([])
  const [favFiles, setFavFiles] = useState<any>([])
  const librariesItems = storePersist?.get("library")?.current;
  const [brandMappings, setBrandMappings] = useState<any>([])
  const [openConfirmationFile, setOpenConfirmationFile] = React.useState(false);
  const [openConfirmationLogoFile, setOpenConfirmationLogoFile] = React.useState(false);
  const [openConfirmationFavFile, setOpenConfirmationFavFile] = React.useState(false);
  const [openImageFile, setOpenImageFile] = useState<any>([]);
  const handleFormLogoItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Logos);
    items[idx] = { ...items[idx], [field]: value };
    setLogoFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Logos: items };
    setBrandMappings(updatedCardValue);
  }
  const handleFormFavItemChange = ({ value, field, idx, cardValue, idx1 }: any) => {
    const items = deepCopy(cardValue.Favicons);
    items[idx] = { ...items[idx], [field]: value };
    setFavFiles(items);
    const updatedCardValue = [...brandMappings];
    updatedCardValue[idx1] = { ...cardValue, Favicons: items };
    setBrandMappings(updatedCardValue);
  }
  //  const fetchBrandMappingsQueryById = () => {
  //     dispatch(brandMappings.query({
  //       url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/brand-mappings/query`,
  //       entity: 'brandMappings',
  //       jsonData: {
  //         Records: [
  //           {
  //             // OwnerTypeId: OWNER_TYPE_ACCOUNT,
  //             OwnerId: parmas?.id,
  //             Id: 0,
  //           }
  //         ]
  //       }
  //     })).then(() => {
  //       setIsQuery(true)
  //     })
  //   }
  const handleFormItemBrandChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(brandMappings);
    let item = items[idx];
    item = { ...item, [field]: value }
    items[idx] = item;
    currentChange = { value, field, idx }
    setBrandMappings(items);
  }

  const handleClose = () => {
    if (openConfirmationFile) {
      setOpenConfirmationFile(false)
    } else if (openConfirmationLogoFile) {
      setOpenConfirmationLogoFile(false)
    } else if (openConfirmationFavFile) {
      setOpenConfirmationFavFile(false)
    }
    dispatch(settings.set({ getUploadFiles: 'close' }))
  }

  const addNewRow = ({ selectedBrandsArg }: any) => {
    const localSelectedBrands = deepCopy(selectedBrandsArg)
    const newsBrand = {
      Id: 0,
      Name: '',
      Description: '',
      Logos: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Favicons: [
        {
          Url: '',
          Size: '',
          Background: '',
        }
      ],
      Branding: {
        Primary: {},
        Secondary: {},
        Tertiary: {},
        Ghost: {}
      }
    }
    if (localSelectedBrands.length === 0 ||
      localSelectedBrands[localSelectedBrands?.length - 1]?.Name !== ''
    ) {
      localSelectedBrands?.push(newsBrand);
    }

    return localSelectedBrands
  }

  const addNewLogoFilesRow = ({ selectedLogoFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedlogo = deepCopy(selectedLogoFilesArg)
    const newSelectedLogo = {
      Url: '',
      Size: '',
      Background: '',
    }

    if (localSelectedlogo.length === 0 ||
      brandMapping[idx1]?.Logos[brandMapping[idx1].Logos?.length - 1]?.Url !== ''
    ) {

      brandMapping[idx1]?.Logos?.push(newSelectedLogo)
    }

    return localSelectedlogo
  }

  const addNewFavFilesRow = ({ selectedFavFilesArg, brandMapping, idx, idx1 }: any) => {
    const localSelectedfav = deepCopy(selectedFavFilesArg)
    const newSelectedFav = {
      Url: '',
      Size: '',
      Background: '',
    }

    if (localSelectedfav.length === 0 ||
      brandMapping[idx1]?.Favicons[brandMapping[idx1].Favicons?.length - 1]?.Url !== ''
    ) {

      brandMapping[idx1]?.Favicons?.push(newSelectedFav)
    }

    return localSelectedfav
  }

  const setCombinationLogoInfo = async () => {
    let localSelectedLogo = deepCopy(logoFiles)
    localSelectedLogo.splice(
      currentChange.idx,
      1,
      { ...localSelectedLogo[currentChange.idx] }
    );
    localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: localSelectedLogo, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setLogoFiles(localSelectedLogo)
  }
  const setCombinationFavInfo = async () => {
    let localSelectedFav = deepCopy(favFiles)
    localSelectedFav.splice(
      currentChange.idx,
      1,
      { ...localSelectedFav[currentChange.idx] }
    );
    localSelectedFav = addNewFavFilesRow({ selectedFavFilesArg: localSelectedFav, brandMapping: brandMappings, idx1: currentChange.idx });
    currentChange.field = 'UrlDONE'
    setFavFiles(localSelectedFav)
  }

  const setCombinationBrandInfo = async () => {
    let localSelectedbrands = deepCopy(brandMappings)
    localSelectedbrands.splice(
      currentChange.idx,
      1,
      { ...localSelectedbrands[currentChange.idx] }
    );
    localSelectedbrands = addNewRow({ selectedBrandsArg: localSelectedbrands });
    currentChange.field = 'NameDONE'
    setBrandMappings(localSelectedbrands)
  }


  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationLogoInfo()
      }
    },
    [currentChange.field, currentChange.idx]
  )
  useEffect(
    () => {
      if (currentChange.field === 'Url') {
        setCombinationFavInfo()
      }
    },
    [currentChange.field, currentChange.idx]
  )
  useEffect(
    () => {
      if (currentChange.field === 'Name') {
        setCombinationBrandInfo()
      }
    },
    [brandMappings]
  )

  const handleLogoSubmit = (data: any) => {

    const newLogoFiles = [...logoFiles];
    const logosArray = brandMappings[currentChange.idx1]?.Logos;
    logosArray[currentChange.idx].Url = data;
    const localSelectedLogo = addNewLogoFilesRow({
      selectedLogoFilesArg: newLogoFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });
    setLogoFiles(localSelectedLogo)
  }

  const changeLogoImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    console.log(brandMaping, 'brandMaping')
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationLogoFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Logos[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    console.log('red logo')
    currentChange = { idx, templateField, idx1 }

  }
  console.log(openImageFile, 'open')
  const changeFavImage = (idx: number, templateField: any, fileType: any, brandMaping: any, idx1: any) => {
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenConfirmationFavFile(true)
    setOpenImageFile({
      currentFileSrc: brandMaping[idx1]?.Favicons[idx][templateField],
      folder: 'Organizationunit',
      type: fileType
    })
    console.log('red Fav')
    currentChange = { idx, templateField, idx1 }

  }


  const handleFavSubmit = (data: any) => {
    const newfavFiles = [...favFiles];
    const favsArray = brandMappings[currentChange?.idx1]?.Favicons;
    favsArray[currentChange?.idx].Url = data;
    const localSelectedFav = addNewFavFilesRow({
      selectedFavFilesArg: newfavFiles,
      brandMapping: brandMappings,
      idx: currentChange.idx,
      idx1: currentChange.idx1,
      data: data
    });

    setFavFiles(localSelectedFav)
  }
  useEffect(
    () => {

      if (cardDetailInfo) {
        let brandMappings: any = null
        brandMappings = [cardDetailInfo[0]?.Configurations]
        let brandData: any = brandMappings?.map((item: any) => {
          const itemData = {
            Id: cardDetailInfo[0]?.Id,
            Name: cardDetailInfo[0]?.Name,
            Description: cardDetailInfo[0]?.Description,
            Theme: cardDetailInfo[0]?.Theme,
            OwnerTypeId: cardDetailInfo[0]?.OwnerTypeId,
            OwnerType: cardDetailInfo[0]?.OwnerType,
            OwnerId: cardDetailInfo[0]?.OwnerId,
            PrimaryColor: item?.Branding?.Primary?.Color,
            PrimaryBackgroundColor: item?.Branding?.Primary?.BackgroundColor,
            PrimaryBackgroundImage: item?.Branding?.Primary?.BackgroundImage,
            SecondaryColor: item?.Branding?.Secondary?.Color,
            SecondaryBackgroundColor: item?.Branding?.Secondary?.BackgroundColor,
            SecondaryBackgroundImage: item?.Branding?.Secondary?.BackgroundImage,
            TertiaryColor: item?.Branding?.Tertiary?.Color,
            TertiaryBackgroundColor: item?.Branding?.Tertiary?.BackgroundColor,
            TertiaryBackgroundImage: item?.Branding?.Tertiary?.BackgroundImage,
            GhostColor: item?.Branding?.Ghost?.Color,
            GhostBackgroundColor: item?.Branding?.Ghost?.BackgroundColor,
            GhostBackgroundImage: item?.Branding?.Ghost?.BackgroundImage,
            Logos: item?.Logos?.map((logoItem: any) => {
              return {
                Url: logoItem.Url,
                Size: logoItem.Size,
                Background: logoItem.Background,
              };
            }),
            Favicons: item?.Favicons?.map((favItem: any) => {
              return {
                Url: favItem.Url,
                Size: favItem.Size,
                Background: favItem.Background,
              };
            }),
          }
          return itemData
        })

        if (!brandData) {
          brandData = []
        }

        const localSelectedbrands = addNewRow({ selectedBrandsArg: brandData });
        setBrandMappings(localSelectedbrands)

        const updatedLogo = brandData.map((brandMapping: any, index: any) => {
          const localSelectedlogo = addNewLogoFilesRow({
            selectedLogoFilesArg: brandMapping?.Logos,
            brandMapping: localSelectedbrands,
            idx: brandMapping?.Logos?.length,
            idx1: index
          });
          return localSelectedlogo;
        });

        setLogoFiles(updatedLogo)
        const updatedFav = brandData.map((brandMapping: any, index: any) => {
          const localSelectedlogo = addNewFavFilesRow({
            selectedFavFilesArg: brandMapping.Favicons,
            brandMapping: localSelectedbrands,
            idx: brandMapping.Favicons.length,
            idx1: index
          });
          return localSelectedlogo;
        });
        setFavFiles(updatedFav)
        setIsLoading(false)
      } else {
        const localSelectedBrands = addNewRow({ selectedBrandsArg: brandMappings });
        setBrandMappings(localSelectedBrands)
        const localSelectedLogo = addNewLogoFilesRow({ selectedLogoFilesArg: logoFiles, brandMapping: brandMappings, idx1: 0 });
        setLogoFiles(localSelectedLogo)

        setIsLoading(false)
      }
    },
    []
  )



  //   useEffect(() => {
  //     let brandMappings: any = null
  //     if (accountsBrandMappingsQuery?.result?.items) {
  //       brandMappings = [accountsBrandMappingsQuery?.result?.items?.Configurations]
  //     }
  //     let brandData: any = brandMappings?.map((item: any) => {
  //       const itemData = {
  //         Id: item?.Id,
  //         Name: item?.Name,
  //         Description: item?.Description,
  //         PrimaryColor: item?.Branding?.Primary?.Color,
  //         PrimaryBackgroundColor: item?.Branding?.Primary?.BackgroundColor,
  //         PrimaryBackgroundImage: item?.Branding?.Primary?.BackgroundImage,
  //         SecondaryColor: item?.Branding?.Secondary?.Color,
  //         SecondaryBackgroundColor: item?.Branding?.Secondary?.BackgroundColor,
  //         SecondaryBackgroundImage: item?.Branding?.Secondary?.BackgroundImage,
  //         TertiaryColor: item?.Branding?.Tertiary?.Color,
  //         TertiaryBackgroundColor: item?.Branding?.Tertiary?.BackgroundColor,
  //         TertiaryBackgroundImage: item?.Branding?.Tertiary?.BackgroundImage,
  //         GhostColor: item?.Branding?.Ghost?.Color,
  //         GhostBackgroundColor: item?.Branding?.Ghost?.BackgroundColor,
  //         GhostBackgroundImage: item?.Branding?.Ghost?.BackgroundImage,
  //         Logos: item?.Logos?.map((logoItem: any) => {
  //           return {
  //             Url: logoItem.Url,
  //             Size: logoItem.Size,
  //             Background: logoItem.Background,
  //           };
  //         }),
  //         Favicons: item?.Favicons?.map((favItem: any) => {
  //           return {
  //             Url: favItem.Url,
  //             Size: favItem.Size,
  //             Background: favItem.Background,
  //           };
  //         }),
  //       }
  //       return itemData
  //     })

  //     if (!brandData) {
  //       brandData = []
  //     }

  //     const localSelectedbrands = addNewRow({ selectedBrandsArg: brandData });
  //     setBrandMappings(localSelectedbrands)

  //     const updatedLogo = brandData.map((brandMapping: any, index: any) => {
  //       const localSelectedlogo = addNewLogoFilesRow({
  //         selectedLogoFilesArg: brandMapping?.Logos,
  //         brandMapping: localSelectedbrands,
  //         idx: brandMapping?.Logos?.length,
  //         idx1: index
  //       });
  //       return localSelectedlogo;
  //     });

  //     setLogoFiles(updatedLogo)
  //     const updatedFav = brandData.map((brandMapping: any, index: any) => {
  //       const localSelectedlogo = addNewFavFilesRow({
  //         selectedFavFilesArg: brandMapping.Favicons,
  //         brandMapping: localSelectedbrands,
  //         idx: brandMapping.Favicons.length,
  //         idx1: index
  //       });
  //       return localSelectedlogo;
  //     });
  //     setFavFiles(updatedFav)
  //   }, [accountsBrandMappingsQuery]);
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    brandMappings.splice(
      brandMappings.length - 1,
      1
    )

    const brandData: any = brandMappings.map((item: any) => {
      if (item?.Logos?.length) {
        item.Logos.splice(item.Logos.length - 1, 1);
      }
      if (item?.Favicons?.length) {
        item.Favicons.splice(item.Favicons.length - 1, 1);
      }
      console.log(item, 'item')
      const itemData = {
        Id: item?.Id,
        OwnerTypeId: item?.OwnerTypeId || 0,
        OwnerId: item?.OwnerId || 0,
        Name: item?.Name,
        Description: item?.Description,
        Theme: item?.Theme,
        Configurations: {
          Logos: item?.Logos?.map((logoItem: any) => {
            return {
              Url: logoItem.Url,
              Size: logoItem.Size,
              Background: logoItem.Background,
            };
          }),
          Favicons: item?.Favicons?.map((favItem: any) => {
            return {
              Url: favItem.Url,
              Size: favItem.Size,
              Background: favItem.Background,
            };
          }),
          Branding: {
            Primary: {
              Color: item?.PrimaryColor,
              BackgroundColor: item?.PrimaryBackgroundColor,
              BackgroundImage: item?.PrimaryBackgroundImage
            },
            Secondary: {
              Color: item?.SecondaryColor,
              BackgroundColor: item?.SecondaryBackgroundColor,
              BackgroundImage: item?.SecondaryBackgroundImage
            },
            Tertiary: {
              Color: item?.TertiaryColor,
              BackgroundColor: item?.TertiaryBackgroundColor,
              BackgroundImage: item?.TertiaryBackgroundImage
            },
            Ghost: {
              Color: item?.GhostColor,
              BackgroundColor: item?.GhostBackgroundColor,
              BackgroundImage: item?.GhostBackgroundImage
            },

          },
        }

      }
      return itemData
    })
    onSubmit(brandData)
  }


  useEffect(() => {
  }, [brandMappings]);

  console.log(openImageFile, 'openFile')
  return (
    <>
      {getUploadFiles == 'open' && openConfirmationLogoFile && <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleLogoSubmit}
        type={openImageFile?.type}
        ownerId={parmas?.id}
      />}
      {getUploadFiles == 'open' && openConfirmationFavFile && <UploadFiles currentFilesSrc={openImageFile?.currentFileSrc}
        folder={openImageFile?.folder}
        handleClose={handleClose}
        handleFilesSubmit={handleFavSubmit}
        type={openImageFile?.type}
        ownerId={parmas?.id}
      />}
      {isLoading ? <PageLoader /> :
        <AccountBrandInfoComponent
          handleClose={handleClose}
          onFormItemBrandChange={handleFormItemBrandChange}
          logoFiles={logoFiles}
          changeFavImage={changeFavImage}
          onFormLogoItemChange={handleFormLogoItemChange}
          faviconSize={librariesItems.FaviconSize}
          changeLogoImage={changeLogoImage}
          logoBackground={librariesItems.LogoBackground}
          brandMappings={brandMappings}
          onFormFavItemChange={handleFormFavItemChange}
          handleFormSubmit={handleFormSubmit}
        />
      }

    </>
  )

}

export default BrandMappingContainer;